/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  SalesOfferableItem
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List offerable license items for the sales request wizard
 */
export const listSalesOfferableItems = (

 signal?: AbortSignal
) => {


      return axiosClient<SalesOfferableItem[]>(
      {url: `/sales/offerable_items`, method: 'GET', signal
    },
      );
    }




export const getListSalesOfferableItemsQueryKey = () => {
    return [
    'sales','offerable_items'
    ] as const;
    }


export const getListSalesOfferableItemsQueryOptions = <TData = Awaited<ReturnType<typeof listSalesOfferableItems>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesOfferableItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSalesOfferableItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesOfferableItems>>> = ({ signal }) => listSalesOfferableItems(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesOfferableItems>>, TError, TData>
}

export type ListSalesOfferableItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesOfferableItems>>>
export type ListSalesOfferableItemsQueryError = ErrorType<unknown>


/**
 * @summary List offerable license items for the sales request wizard
 */

export function useListSalesOfferableItems<TData = Awaited<ReturnType<typeof listSalesOfferableItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesOfferableItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSalesOfferableItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






